import { UserType } from '../types';
import { FieldTypes, WebEntity } from './types';

const UserEntity: WebEntity<UserType> = {
  name: 'userType',
  endpoint: 'userAccountTypes',
  referenceColumn: 'userTypeName',
  customButtonNames: {
    addButtonName: 'Agregar Tipo de Usuario'
  },
  customDataActions: {
    addModalTitle: 'Agregar Tipo de Usuario',
    editModalTitle: 'Editar Tipo de Usuario'
  },
  tableColumns: [
    {
      header: 'ID',
      accessorKey: '_id',
      omitExport: true,
      columnType: 'text',
      enableHiding: false,
      visibleInShowHideMenu: false
    },
    {
      header: 'Nombre Usuario',
      accessorKey: 'userTypeName',
      columnType: 'text'
    }
  ],

  fields: [
    {
      name: 'Nombre',
      selector: 'userTypeName',
      type: FieldTypes.Text,
      required: true
    }
  ],

  editableFields: [
    {
      name: 'Nombre',
      selector: 'userTypeName',
      type: FieldTypes.Text,
      required: true
    }
  ]
};

export default UserEntity;
